<template>
  <div id="logged-out" class="logged-out">
    <div class="logged-out__content">
      <section class="logged-out__information-text">
        <h2 class="logged-out__information-title">{{ i18n._('DISPONIBLE DANS LES DÉCLINAISONS SUIVANTES :') }}</h2>
        <ul class="logged-out__variant-list">
          <li
            class="logged-out__variant-list__item"
            data-test="variant-item"
            v-for="variant in availableVariants"
            :key="variant.id"
          >
            {{ variant.name }}
          </li>
        </ul>
      </section>
      <adn-button class="logged-out__see-price-btn" @click="showModal" data-test="showModal">
        {{ i18n._('Voir les prix') }}
      </adn-button>
    </div>
    <p-prices-modal :show-prices-modal="showPricesModal" @after-hide="afterHide" />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref, type PropType } from 'vue'
import PPricesModal from '../PPricesModal/PPricesModal.vue'
import { i18n } from '@b2ag/locale'
import type { Product } from '../typings'
import AdnButton from '@b2ag/design-system/src/components/AdnButton/AdnButton.vue'

export default defineComponent({
  name: 'PProductLoggedOut',
  props: {
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
  },
  components: {
    PPricesModal,
    AdnButton,
  },
  setup(props) {
    const showPricesModal = ref(false)

    const product = computed(() => props.product)
    const availableVariants = computed(() =>
      product.value.variants.filter((variant) => (variant.offline !== undefined ? !variant.offline : variant.sellable)),
    )

    const afterHide = () => {
      showPricesModal.value = false
    }
    const showModal = () => {
      showPricesModal.value = !showPricesModal.value
    }

    return {
      showPricesModal,
      availableVariants,
      afterHide,
      showModal,
      i18n,
    }
  },
})
</script>

<style scoped lang="scss">
.logged-out {
  text-align: center;
  padding: 1.6rem;
  margin: 3rem 1.6rem;
  border-radius: 8px;
  background: var(--color-main-background);

  @media (min-width: $breakpoint-sm) {
    margin: 3rem 0;
  }
}

.logged-out__content {
  background: var(--color-white);
  padding: 1.6rem;
  border-radius: 8px;
}

.logged-out__information-text {
  margin-bottom: 1rem;
}

.logged-out__information-title {
  font-size: var(--font-size-m);
  text-align: left;
  font-weight: bold;
  line-height: var(--line-height-s);
  margin-bottom: 2rem;
}

.logged-out__variant-list {
  display: flex;
  justify-content: center;
  text-align: left;
  white-space: nowrap;
  margin-left: 1.6rem;
  list-style: disc;
  flex-wrap: wrap;

  @media (min-width: $breakpoint-sm) {
    text-align: center;
    margin-left: 0;
  }
}

.logged-out__variant-list__item {
  padding: 0 var(--spacing-2);
  position: relative;
  white-space: break-spaces;

  @media (min-width: $breakpoint-sm) {
    list-style: none;

    &:not(:last-child)::after {
      content: '';
      position: absolute;
      display: block;
      width: 1px;
      top: 20%;
      bottom: 20%;
      right: 0;
      background-color: var(--color-black);
    }
  }
}

.logged-out__see-price-btn {
  padding: 0;
  width: 100%;

  @media (min-width: $breakpoint-sm) {
    width: auto;
    padding: 0 7rem;
  }
}
</style>
